import { FontFamily, resolveFontFamily } from './font-family';
import { ThemeConfig } from './theme';

export type TypographyVariantConfig = {
  'font-family': FontFamily;
  'font-size': string | number;
  'font-weight': string | number;
  'line-height': string | number;
  'letter-spacing': string | number;
};

export type TypographyConfig = {
  marquee: TypographyVariantConfig;
  body: TypographyVariantConfig;
  header: TypographyVariantConfig;
  label: TypographyVariantConfig;
  caption: TypographyVariantConfig;
  postscript: TypographyVariantConfig;
};

export type TypographyVariant = keyof TypographyConfig;

export type TypographyCSS = {
  fontFamily: string;
  fontSize: string | number;
  fontWeight: string | number;
  lineHeight: string | number;
  letterSpacing: string | number;
};

export const resolveTypography =
  (theme: ThemeConfig) =>
  (variant: TypographyVariant): TypographyCSS => ({
    fontFamily: resolveFontFamily(theme)(
      theme.typography[variant]['font-family']
    ),
    fontSize: theme.typography[variant]['font-size'],
    fontWeight: theme.typography[variant]['font-weight'],
    lineHeight: theme.typography[variant]['line-height'],
    letterSpacing: theme.typography[variant]['letter-spacing'],
  });
